import {ApiAuthTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class ApiAuthTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in ApiAuthTypeCd ) {
      this._values.push(ApiAuthTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): ApiAuthTypeCd {

    for ( const obj in ApiAuthTypeCd ) {
      if (ApiAuthTypeCd[obj] === value){
        return ApiAuthTypeCd[obj] as ApiAuthTypeCd;
      }
    }
  }
}

const ApiAuthTypeCdHelper = new ApiAuthTypeCdHelperEnumHelperClass();
export default ApiAuthTypeCdHelper;
